import { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  VideoListItem,
  OptionText,
  OrderList,
  Segment,
  Title,
  TitleIndicate,
  ItaticText,
} from "components/User/Evaluation/styles";
import { videoUploadTabs } from "constants/eval_constants";

interface InstructionProps {
  submitButton: (videoId: number) => JSX.Element;
}

interface InstructionState {}

type Props = InstructionProps & RouteComponentProps & WithTranslation;

class Instruction extends Component<Props, InstructionState> {
  render() {
    const { t } = this.props;
    const { submitButton } = this.props;
    return (
      <>
        <Segment>
          <TitleIndicate />
          <Title>{t("user.survey.corePro.video.instruction.title")}</Title>
        </Segment>
        <Segment>
          <ItaticText>
            {t("user.survey.corePro.video.instruction.message")}
          </ItaticText>
          
          {t("user.survey.corePro.video.instruction.opening1a") && (
            <OrderList style={{ marginLeft: "20px", marginRight: "30px", marginTop: "30px" }}>
              <VideoListItem>
                <OptionText>
                  {t("user.survey.corePro.video.instruction.opening1a")}
                </OptionText>
              </VideoListItem>
            </OrderList>
          )}
        </Segment>
        {submitButton(videoUploadTabs.instruction)}
      </>
    );
  }
}

export default withRouter(withTranslation()(Instruction));
